import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const GALLERY_SLUGS = new Set(['ai-living-room-gallery', 'ai-bedroom-gallery', 'ai-kitchen-gallery']);

const LEGACY_GALLERY_SLUGS = {
  'living-room-gallery': 'ai-living-room-gallery',
  'bedroom-gallery': 'ai-bedroom-gallery',
  'kitchen-gallery': 'ai-kitchen-gallery',
};

export function GallerySlugRedirect() {
  const { gallerySlug } = useParams();

  useEffect(() => {
    if (GALLERY_SLUGS.has(gallerySlug)) {
      window.location.replace(`/gallery/${gallerySlug}/`);
    } else if (LEGACY_GALLERY_SLUGS[gallerySlug]) {
      window.location.replace(`/gallery/${LEGACY_GALLERY_SLUGS[gallerySlug]}/`);
    } else {
      window.location.replace('/gallery/');
    }
  }, [gallerySlug]);

  return (
    <p style={{ padding: '2rem', textAlign: 'center', color: '#586174' }} aria-live="polite">
      Opening gallery…
    </p>
  );
}
